import { z } from 'zod';

import { nullishDefault } from '../../../utils/nullableDefault';

export const BeschaeftigungAzubi = z.object({
    ausbildungsVerguetungMonatlich: nullishDefault(z.number()),
    endeDerAusbildung: nullishDefault(z.coerce.date()),
    schulName: nullishDefault(z.string()),
    schulStandort: nullishDefault(z.string()),
});
